import { render, staticRenderFns } from "./DegreeOfDependence.vue?vue&type=template&id=17c282db&scoped=true&"
import script from "./DegreeOfDependence.vue?vue&type=script&lang=js&"
export * from "./DegreeOfDependence.vue?vue&type=script&lang=js&"
import style0 from "./DegreeOfDependence.vue?vue&type=style&index=0&id=17c282db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c282db",
  null
  
)

export default component.exports